import { makeStyles } from "@material-ui/core"

export default makeStyles(() => ({
    flexColumn: {
        display: "flex",
        flexDirection: "column",
        marginBottom: 40
    },
    capitalized: {
        textTransform: "uppercase"
    },
    marginBottom1: {
        marginBottom: "1rem"
    }
}))
